import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/root.css";
import Logo from "../assets/images/anisija/anisija-logo.svg";
import { useLocale } from "../context/LocaleContext";

function Navbar() {
  const { t, lang, setLang } = useLocale();
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <img className="logo-img" src={Logo} alt="Anisija Logo" />
        <div className="navbar-title">
          <h1>Anisija</h1>
          <p>{t.nav.tagline}</p>
        </div>
      </Link>
      <div className="navbar-actions">
        <div className="navbar-links">
          <Link
            to="/"
            className={`navbar-link${isActive("/") ? " active" : ""}`}
          >
            {t.nav.home}
          </Link>
          <Link
            to="/news"
            className={`navbar-link${isActive("/news") ? " active" : ""}`}
          >
            {t.nav.news}
          </Link>
          <Link
            to="/about"
            className={`navbar-link${isActive("/about") ? " active" : ""}`}
          >
            {t.nav.about}
          </Link>
        </div>

        <div className="navbar-lang">
          <button
            type="button"
            onClick={() => setLang("mk")}
            className={`navbar-lang-option${lang === "mk" ? " active" : ""}`}
          >
            {t.nav.languages.mk}
          </button>
          <span className="navbar-lang-divider">|</span>
          <button
            type="button"
            onClick={() => setLang("en")}
            className={`navbar-lang-option${lang === "en" ? " active" : ""}`}
          >
            {t.nav.languages.en}
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
